import React from "react";
import SocialIcons from "../SocialIcons";

export default function FollowMovement() {
  return (
    <section className="relative py-24 overflow-hidden" data-testid="follow-movement">
      <div className="absolute inset-0 pointer-events-none opacity-40"
           style={{ background: "radial-gradient(ellipse at 20% 30%, #4B2E83 0%, transparent 55%), radial-gradient(ellipse at 80% 70%, #D4AF37 0%, transparent 55%)" }} />
      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <div className="text-[#D4AF37] text-xs tracking-[0.4em] uppercase mb-5">SAT Community</div>
        <h2 className="serif text-4xl md:text-6xl font-light tracking-tight leading-[1.05]">
          Folge der<br/><span className="italic" style={{ color: "#D4AF37" }}>SAT Bewegung.</span>
        </h2>
        <p className="text-white/65 text-base md:text-lg mt-8 max-w-2xl mx-auto leading-relaxed">
          Werde Teil einer wachsenden Gemeinschaft von Menschen, die ihr Leben bewusst gestalten und ihre wahre Kraft entfalten möchten. Folge uns auf unseren Kanälen und erhalte regelmäßig Inspirationen, Impulse und Transformationswissen.
        </p>
        <div className="mt-12">
          <SocialIcons variant="cta" />
        </div>
      </div>
    </section>
  );
}
